<template>
    <div class="list">
        <div class="list__column">
            <div
                is="CategoriesListButton"
                v-for="category in categoriesLeft"
                :category="category"
                :key="category.id"
            ></div>
        </div>
        <div class="list__column">
            <div
                is="CategoriesListButton"
                v-for="category in categoriesRight"
                :category="category"
                :key="category.id"
            ></div>
        </div>
    </div>
</template>

<script>
    import CategoriesListButton from './CategoriesListButton';

    export default {
        name: 'CategoriesList',
        components: {
            CategoriesListButton
        },
        computed: {
            categories () {
                return this.$store.state.categories.all;
            },
            categoriesLeft () {
                return this.categories.filter((item, index) => {
                    return index % 2 === 0;
                });
            },
            categoriesRight () {
                return this.categories.filter((item, index) => {
                    return index % 2 === 1;
                });
            }
        },
        created () {
            this.$store.dispatch('getCategories');
        }
    }
</script>

<style lang="scss" scoped>
    .list {
        display: flex;
        text-align: center;

        &__column {
            flex: 50%;
        }
    }

    @media screen and (max-width: 600px) {
        .list {
            display: block;

            &__column {
                flex: none;
            }
        }
    }
</style>